import React from 'react'
import _ from 'lodash'

import {Row, Col} from 'react-flexbox-grid'
import {Link} from 'react-router'

import {Button, Modal, Select, Menu, Icon} from 'antd'

import {MessageStore, QueryService} from 'api/message'

import {BufferCell} from './BufferCell.jsx'
import {PickColumns} from '../ui/PickColumns.jsx'
import {QueryInput} from './QueryInput.jsx'
import {DateTimeRange} from './DateTimeRange.jsx'

import {QueryTable} from './QueryTable.jsx'

const nullOrSplit = (value, delimeter) => (null === value ? null : value.split(delimeter))

const Sidebar = ({
   query,
   availableColumns,
   setParameter,
   loading,
   abortQuery,
   runQuery,
   ..._props
}) => {
   return (
      <div className="facets">
         <div className="facet datetime">
            <h4>Query Range</h4>

            <DateTimeRange
               from={query['date.from'] || null}
               to={query['date.to'] || null}
               update={setParameter}
               disableTo={'true' === _.get(query, 'continuous', 'false')}
            />
         </div>

         <div className="facet query">
            <h4>Query</h4>

            <QueryInput
               query={_.get(query, 'query', '')}
               update={(value, commit) => setParameter('query', value, true === commit)}
               availableColumns={availableColumns}
            />
         </div>

         <div className="facet columns">
            <h4>Show Columns</h4>

            <PickColumns
               columns={nullOrSplit(_.get(query, 'columns', null), ',')}
               onUpdate={(cols, setURL) => setParameter('columns', cols, setURL)}
               options={_.map(availableColumns, label => {
                  return {label, value: label}
               })}
            />
         </div>

         <div className="facet data-fmt">
            <h4>Data Format</h4>
            <Select
               defaultValue="ascii"
               value={_.get(query, '_opts.bufferFmt', 'ascii')}
               onChange={value => setParameter('_opts.bufferFmt', value, true)}
               style={{width: '100%'}}
            >
               {_.map(BufferCell.formats, label => (
                  <Select.Option key={label}>{label}</Select.Option>
               ))}
            </Select>
         </div>

         <div className="facet actions text-right">
            <div>
               <label>
                  <input
                     type="checkbox"
                     checked={'true' === _.get(query, 'continuous', 'false')}
                     onChange={_ev =>
                        setParameter('continuous', ('true' !== query.continuous).toString(), true)}
                  />

                  Continuous query
               </label>
            </div>

            <div>
               <Button
                  onClick={abortQuery}
                  style={{
                     display: 'true' === _.get(query, 'continuous') && !!loading
                        ? 'initial'
                        : 'none'
                  }}
                  icon="close"
               >
                  Cancel
               </Button>
               <Button loading={!!loading} icon="search" onClick={runQuery} type="primary">
                  Query
               </Button>
            </div>
         </div>
      </div>
   )
}

Sidebar.propTypes = {
   query:            React.PropTypes.object.isRequired,
   setParameter:     React.PropTypes.func.isRequired,
   loading:          React.PropTypes.bool,
   abortQuery:       React.PropTypes.func.isRequired,
   runQuery:         React.PropTypes.func.isRequired,
   availableColumns: React.PropTypes.array.isRequired
}

const serialize2 = ([path, acc], v, k) => {
   const realpath = !k ? path : path.concat([k])

   if (_.isObject(v) && !_.isArray(v)) {
      _.each(v, (v2, k2) => serialize2([realpath, acc], v2, k2))

      return [path, acc]
   } else {
      acc[realpath.join('.')] = v

      return [path, acc]
   }
}

const serialize = obj => serialize2([[], {}], obj)[1]

export class Query extends React.Component {
   static get propTypes() {
      return {
         params:   React.PropTypes.object.isRequired,
         location: React.PropTypes.object.isRequired,
         router:   React.PropTypes.object.isRequired
      }
   }

   constructor() {
      super()

      this.state = {
         query:        {_opts: {}},
         showAside:    true,
         queryRunning: null,
         queryStream:  null,
         error:        null,
         // options related to parsing the response
         respOpts:     null
      }

      this.setParameter = this.setParameter.bind(this)
      this.onQuery = this.onQuery.bind(this)
      this.abortQuery = this.abortQuery.bind(this)
   }

   componentWillMount() {
      this._mounted = true
      this.setQuery(this.props.location.query)
      MessageStore.addChangeListener(
         (this._changeListener = () => {
            if (this._mounted) {
               this.setState(state => state)
            }
         })
      )
   }

   componentWillUnmount() {
      this._mounted = false

      MessageStore.removeChangeListener(this._changeListener)
   }

   // componentWillReceiveProps() {
   //    this.setQuery(this.props.location.query)
   // }

   setQuery(query) {
      let [q1, q2] = _.reduce(
         query,
         ([a, b], v, k) => {
            if (0 !== k.indexOf('_opts')) {
               b[k] = v
            }

            return [0 === k.indexOf('_opts') ? _.set(a, k, v) : a, b]
         },
         [{}, {}]
      )

      this.setState({query: _.merge(q1, q2, this.state.query)})
   }

   setParameter(k, v, setURL) {
      // check if continuous transitions from 'true' -> 'false' if so cancel query
      if ('continuous' === k && 'true' === _.get(this.state, 'query.continuous', 'false')) {
         this.abortQuery()
      }

      this.setState(
         state => {
            let newstate = state

            if (0 === k.indexOf('_opts')) {
               newstate = _.set(state, 'query.' + k, _.isArray(v) ? v.join(',') : v)
            } else {
               newstate.query[k] = _.isArray(v) ? v.join(',') : v
            }

            return newstate
         },
         () => {
            if (setURL) {
               this.serializeQueryToUrl(this.state.query)
            }
         }
      )
   }

   abortQuery() {
      if (this.state.queryStream) {
         this.state.queryStream.abort()
      }
   }

   serializeQueryToUrl(query) {
      const {router, location} = this.props

      router.replace({...location, query: serialize(query)})
   }

   onQuery() {
      const {params} = this.props,
         {query} = this.state

      // if continous  call QueryService.open, otherwise QueryService.fetch
      let resource, result

      resource = params.nid + (params.key ? '/' + params.key : '')

      if (this.state.queryRunning) {
         return this.state.queryRunning
      }

      if (this.state.queryStream) {
         QueryService.close(this.state.queryStream)
      }

      this.serializeQueryToUrl(this.state.query)

      this.setState({queryStream: null, queryRunning: false, error: null})

      if ('true' === query.continuous) {
         result = QueryService.stream(resource, query, null, true)
            .then(({xhr: res, opts: respOpts}) => {
               const afterReq = (_ev, cb) => {
                  this.setState({queryStream: null, queryRunning: null}, cb)
               }

               this.setState({queryStream: res, queryRunning: result, respOpts})

               res.addEventListener('load', afterReq)
               res.addEventListener('error', ev =>
                  afterReq(ev, () => this.onQueryError(ev, 'Unexpected Network Error'))
               )
               res.addEventListener('abort', afterReq)
            })
            .catch(err =>
               this.setState({queryStream: null, queryRunning: null}, () => this.onQueryError(err))
            )
      } else {
         result = QueryService.query(resource, query, null, true, true)
            .then(({opts: respOpts}) => {
               this.setState({queryStream: null, queryRunning: false, respOpts})
            })
            .catch(err =>
               this.setState({queryStream: null, queryRunning: false}, () => this.onQueryError(err))
            )
      }

      this.setState({queryStream: result, queryRunning: true})

      return result
   }

   onQueryError(error, msg) {
      this.setState({error: msg})

      Modal.confirm({
         title:      'Error in query',
         content:    msg || error.toString(),
         okText:     'Retry',
         cancelText: 'Cancel',
         onOk:       this.onQuery,
         onCancel:   () => null
      })
   }

   render() {
      const {query, respOpts, showAside, queryRunning, error} = this.state,
         queryOpts = _.merge(_.clone(query), {_opts: respOpts || {}})

      let progressState = 'none'

      if (true === queryRunning) {
         progressState = 'waiting'
      } else if (queryRunning) {
         progressState = 'running'
      } else if (error) {
         progressState = 'error'
      }

      return (
         <Row>
            <Col xs={4} style={{display: showAside ? 'initial' : 'none'}}>
               <Sidebar
                  runQuery={this.onQuery}
                  loading={null !== queryRunning && false !== queryRunning}
                  query={queryOpts}
                  abortQuery={this.abortQuery}
                  setParameter={this.setParameter}
                  availableColumns={MessageStore.columns}
               />

               <Menu>
                  <Menu.Divider />

                  <Menu.Item>
                     <Link onClick={() => this.setState({showAside: false})}>
                        <Icon type="menu-fold" />
                        Hide Sidebar
                     </Link>
                  </Menu.Item>
               </Menu>

            </Col>

            <Col xs={showAside ? 8 : 12}>
               <div className={`progress-state ${progressState}`} style={{marginBottom: '1em'}}>
                  <div className={`bar ${error ? '' : 'animating'}`} />
               </div>

               <QueryTable redraw={showAside} query={query} setParameter={this.setParameter} />

               {showAside
                  ? null
                  : <Menu selectedKeys={['noop']}>
                       <Menu.Item>
                          <Link onClick={() => this.setState({showAside: true})}>
                             <Icon type="menu-unfold" /> Show Sidebar
                          </Link>
                       </Menu.Item>
                    </Menu>}
            </Col>
         </Row>
      )
   }
}

Query.sidebar = true



// WEBPACK FOOTER //
// lib/bundle/dashboard/query/index.js